import linkButtonStyles from '@github-ui/code-view-shared/css/LinkButton.module.css'
import {useCurrentRepository} from '@github-ui/current-repository'
import {invitationsPath, ownerPath} from '@github-ui/paths'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {Flash, Link, LinkButton} from '@primer/react'

import styles from './PendingInvitationBanner.module.css'

export default function PendingInvitationBanner({inviterName}: {inviterName: string}) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()
  const {ownerLogin, name} = useCurrentRepository()

  return (
    <Flash>
      <div className={styles.Box}>
        <div className={styles.Box_1}>
          <Link
            href={ownerPath({owner: inviterName})}
            {...getHovercardAttributesForType('user', {login: inviterName})}
            className={styles.Link}
          >
            @{inviterName}
          </Link>
          &nbsp;has invited you to collaborate on this repository
        </div>
        <>
          <LinkButton href={invitationsPath({owner: ownerLogin, repo: name})} className={linkButtonStyles.linkButton}>
            View invitation
          </LinkButton>
        </>
      </div>
    </Flash>
  )
}
